import { useEffect, useRef, useState } from 'react'
import checkMarketFlag from '../../../services/marketFlags'

export const FLAG_KEY = 'costentory-enable-inventory-transfer-orders'

export function useMarketTransferOrderFlag( branchId?: string | null ) {
	const useNewFlowRef = useRef( false )
	const [ isLoading, setIsLoading ] = useState( false )

	useEffect( () => {
		let cancelled = false

		if ( branchId ) {
			setIsLoading( true )
			checkMarketFlag( FLAG_KEY, String( branchId ) ).then( ( result ) => {
				if ( cancelled ) {
					return
				}
				useNewFlowRef.current = result
				setIsLoading( false )
			} )
		}

		return () => {
			cancelled = true
		}
	}, [ branchId ] )

	return { useNewFlowRef, isLoading }
}
